import http from '../api/http'

export default {
  findByToken: () => { return http.get('/employees/find-by-token') },
  login: (credentials) => { return http.post('/employees/login', credentials) },
  logout: () => { return http.post('/employees/logout', null) }
}
